export default __webpack_public_path__ + "static/media/partnerSolutionBG.37c05c03.jpg";